import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError } from 'rxjs/operators';

import * as vttActions from '../actions/vtt.actions';
import { VttHttpService } from '../services';

@Injectable()
export class VttEffects {
  constructor(
    private actions$: Actions,
    private vttHttpService: VttHttpService
  ) {}

  /** Load all VTT files */
  loadVtt$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<vttActions.LoadVtt>(vttActions.VttActionTypes.LOAD),
      switchMap((action: vttActions.LoadVtt) =>
        this.vttHttpService.load(action.companyId,action.asset_id).pipe(
          map((response) => new vttActions.LoadVttSuccess(response)),
          catchError((error: any) => of(new vttActions.LoadVttFail(error)))
        )
      )
    )
  );

  /** Add a new VTT file */
  addVtt$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<vttActions.AddVtt>(vttActions.VttActionTypes.ADD),
      switchMap((action: vttActions.AddVtt) =>
        this.vttHttpService.add(action.companyId, action.asset_id, action.payload).pipe(
          map(() => new vttActions.AddVttSuccess()),
          catchError((error: any) => of(new vttActions.AddVttFail(error)))
        )
      )
    )
  );

  /** Edit an existing VTT file */
  editVtt$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<vttActions.EditVtt>(vttActions.VttActionTypes.EDIT),
      switchMap((action: vttActions.EditVtt) =>
        this.vttHttpService.update(action.companyId, action.asset_id, action.payload).pipe(
          map((response) => new vttActions.EditVttSuccess(response)),
          catchError((error: any) => of(new vttActions.EditVttFail(error)))
        )
      )
    )
  );

  /** Delete a VTT file */
  deleteVtt$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<vttActions.DeleteVtt>(vttActions.VttActionTypes.DELETE),
      switchMap((action: vttActions.DeleteVtt) =>
        this.vttHttpService.deletevtt(action.companyId, action.asset_id, action.track_id).pipe(
          map(() => new vttActions.DeleteVttSuccess()),
          catchError((error: any) => of(new vttActions.DeleteVttFail(error)))
        )
      )
    )
  );
}
